<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                type="list"
                v-decorator="[
                  'orgCode',
                  // { initialValue: initCompanyCode, rules: validatorRules.companyCode.rules }
                   {rules: validatorRules.companyCode.rules }
                ]"
                :triggerChange="true"
                :dictOptions="companyOptions"
                placeholder="请选择公司"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="使用场景" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['scene', validatorRules.scene]" :trigger-change="true" dictCode="sys_scene" placeholder="请选择使用场景" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="设置参数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-radio-group v-decorator="['parameter', { initialValue: 'Y' }]">
                <a-radio value="Y">是</a-radio>
                <a-radio value="N">否</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-radio-group v-decorator="['validFlag', { initialValue: 'Y' }]">
                <a-radio value="Y">是</a-radio>
                <a-radio value="N">否</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'SysConfigForm',
    components: {
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          orgCode: {
            rules: [
              { required: true, message: '请输入机构编码!'},
            ]
          },
          scene: {
            rules: [
              { required: true, message: '请输入使用场景!'},
            ]
          },
          parameter: {
            rules: [
              { required: true, message: '请输入设置参数!'},
            ]
          },
          validFlag: {
            rules: [
              { required: true, message: '请输入是否有效!'},
            ]
          },
          companyCode: { rules: [{ required: true, message: '请选择公司!' }] },
        },
        url: {
          add: "/system/sysConfig/add",
          edit: "/system/sysConfig/edit",
          queryById: "/system/sysConfig/queryById",
          companyUrl: '/sys/sysDepart/getDepartListByPermission'
        },
        companyOptions: [],
        initCompanyCode: null,
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
      // 获取公司列表
      this.getCompanyOptions()
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'orgCode','scene','parameter','createBy','createTime','updateBy','updateTime','validFlag'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'orgCode','scene','parameter','createBy','createTime','updateBy','updateTime','validFlag'))
      },
      getCompanyOptions () {
        let that = this
        getAction(this.url.companyUrl, { orgCategory: '1' }).then((res) => {
          if (res.success) {
            console.log(res)
            that.companyOptions = res.result
          }
        })
      },
    },
  }
</script>